/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Route } from 'react-router-dom';
import { lazyLoadComponent } from '~shared/helpers/lazyLoadComponent';

const ProjectBranchesApp = lazyLoadComponent(() => import('./ProjectBranchesApp'));

const routes = () => <Route element={<ProjectBranchesApp />} path="branches" />;

export default routes;
